export const aciSummer = {
    iconName: 'summer',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M8.993 14.735V5.4A2.4 2.4 0 006.592 3a2.402 2.402 0 00-2.401 2.4v9.335a3.594 3.594 0 004.369 5.683 3.595 3.595 0 001.634-3.018 3.575 3.575 0 00-1.2-2.665zM6.592 6.6v9.6',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M5.39 17.4a1.2 1.2 0 102.4 0 1.2 1.2 0 00-2.4 0zM11.396 11.4a3 3 0 003.001 3 3.003 3.003 0 003.002-3 3 3 0 00-3.002-3 3.003 3.003 0 00-3.002 3zM14.997 6V4.8M18.218 7.582l.849-.85M19.8 11.4H21M18.218 15.219l.849.849M14.997 16.8V18',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
